<template>
  <div v-if="morePhotos" class="catalog-slider" @wheel.prevent>
    <DefSlider
      ref="horizontal"
      :settings="main"
      :nav="true"
      :pagination="true"
      class="catalog-slider-main"
    >
      <div v-for="(item, i) in morePhotos" :key="i" class="swiper-slide">
        <img :src="item.src" :alt="item.alt" />
      </div>
      <GiaPhoto v-if="result?.isGia" />
    </DefSlider>
  </div>
</template>

<script>
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'CatalogSlider',
  components: { GiaPhoto, DefSlider },
  props: ['result'],
  data: () => ({
    main: {
      slidesPerView: 1,
    },
    screenWidth: useScreenWidth(),
  }),
  computed: {
    morePhotos() {
      return this.result?.morePhotos;
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-slider-main {
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  :deep(div.swiper-scrollbar) {
    width: 1px;
    height: 100%;
    margin: 0 8px;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 100px;
  }
  :deep(.def-slider__prev) {
    left: -12px;
  }
  :deep(.def-slider__next) {
    right: -12px;
  }
  :deep(.def-slider__default-button) {
    background-color: transparent;
  }
  :deep(.def-slider__container) {
    width: 100%;
  }
}
</style>
